module.exports = __webpack_public_path__ + "media/backgrounds/thilak-mohan-3FprkLEJ2gQ-unsplash-42824b88.jpg";